export const text =
`
So what *is* the homepage tile contest...

Okay, so I haven't written this page yet.  But I did make this gif of an AI trying (and eventually *kinda* succeeding) at creating a "vampire in a wedding veil."

![vampire clip](./vampire-woman-gif-clip-guided-diffusion.gif)
`
